import { Box } from '@mui/material';
import { FC } from 'react';
import Lottie from "lottie-react";
import chatAnimation from 'shared/assets/animations/chatfile.json';

export const ChatAnimation: FC = () => {
    return (
        <Box
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: "column",
                borderRadius: "14px",
                width: "100%",
                height: "100%" 
            }}
        >
            <Lottie
                animationData={chatAnimation}
                loop={true}
                autoplay={true}
                style={{ width: 150, height: 150 }}
            />
        </Box>
    );
};

export default ChatAnimation;